import BaseUICustomerEditingView from 'xui/modules/contact/BaseUICustomerEditingView'

class CCustomerEditingView extends BaseUICustomerEditingView {}

export default CCustomerEditingView
